import { render, staticRenderFns } from "./Edituser_Tutor.vue?vue&type=template&id=6a598485&scoped=true&"
import script from "./Edituser_Tutor.vue?vue&type=script&lang=js&"
export * from "./Edituser_Tutor.vue?vue&type=script&lang=js&"
import style0 from "./Edituser_Tutor.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Edituser_Tutor.vue?vue&type=style&index=1&id=6a598485&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a598485",
  null
  
)

export default component.exports